import React from 'react';
import { location } from 'ionicons/icons';
import { IonIcon } from '@ionic/react';
import '../../../styles/fight/takerProcess/AddressCompactCard.scss';

const AddressCompactCard = ({ isAddressValid, addressLine, onEdit }) => {
  return (
    <div className='item-wrapper address-wrapper'>
      <IonIcon icon={location} />
      <p className='address-text'>
        {isAddressValid ? addressLine : <span className='invalid-address-text'>Invalid Address</span>}
      </p>
      <button type='button' onClick={onEdit} className='change-text'>
        Edit
      </button>
    </div>
  );
};

export default AddressCompactCard;
